import { LOG_OUT } from '../auth/actionTypes';
import { CLEAN_REDUCER, FETCH_BRANDINGS } from './actionTypes';

const initState = {
	brandings: [],
	brandingCount: 0,
};

const reducer = (state = initState, action) => {
	switch (action.type) {
		case FETCH_BRANDINGS:
			return {
				...state,
				brandings: action.brandings,
			};
		case CLEAN_REDUCER:
		case LOG_OUT:
			return initState;
		default:
			return state;
	}
};

export default reducer;
